import '../App.css';
import Navigation from '../componets/Navigation'
import Footer from '../componets/Footer';
import { globalVar } from '../globalVar';
function Ogloszenia() {
  return (<>
        <Navigation />
        <div className='article'>
            <div className='title'>Ogłoszenia {globalVar.map((map,index) => {return map.niedziela})} </div>
            <p>Kalednarz liturgiczny</p>
            <p>
                Weszliśmy w Wielki Tydzień, w czasie którego dotkniemy najważniejszych
                wydarzeń dzieła zbawienia, które podjął Syn Boży, Jezus Chrystus. Do głębszego
                przeżycia tych tajemnic, przygotowaliśmy się w czasie rekolekcji. W dniu dzisiejszym
                wspominamy triumfalny wjazd Jezusa do Jerozolimy.
            </p>

            <p>
                Dziękuję za sprzątanie kościoła na dzisiejszą niedzielę i ofiarę 200zł, proszę o
                przygotowanie świątynii na czasa świąteczny (w czwartek) rodziny:
            </p>
            <div className="title">TRIDUUM SACRUM</div>

        <div className="subtitle">WIELKI CZWARTEK</div>
        <p>
            Wspomnienie dnia, w którym podczas Ostatniej Wieczerzy, Chrystus ustanowił
            sakrament Kapłaństwa i Eucharystii.
        </p>
        <p>
            Msza św. Wieczerzy Pańskiej o godz. 18.00, po jej zakończeniu, przeniesienie
            Najświętszego Sakramentu do Ciemnicy i adoracja indywidualna do godz. 22.00.
        </p>

        <div className="subtitle">WIELKI PIĄTEK</div>
        <p>
            Wspomnienie Męki i Śmierci naszego Zbawiciela. Dzień, w którym nie sprawuje się
            Mszy św. Obowiązuje post ścisły – ilościowy i jakościowy – trzy posiłki w ciągu dnia, w
            tym jeden do syta, i wstrzemięźliwość od pokarmów mięsnych.
        </p>
        <ul>
            <li>Adoracja w Ciemnicy od godz. 6.00 do godz. 17.00</li>
            <li>Droga Krzyżowa o godz. 15.00</li>
            <li>Liturgia Męki Pańskiej o godz. 18.00, jej kulminacyjną częścią będzie adoracja Krzyża</li>
            <li>Po zakończeniu liturgii: przeniesienie Najświętszego Sakramentu do Grobu Pańskiego</li>
            <li>Odśpiewamy 3 części Gorzkich Żali i trwać będziemy w adoracji do soboty do godz. 17.30</li>
            <li>Prośba do Druhów i Druhen OSP o wartę przy Grobie Pańskim</li>
            <li>Ofiary z adoracji Krzyża przeznaczone na Bazylikę Grobu Pańskiego w Jerozolimie</li>
            <li>Spowiedź: od godz. 6.00 do 7.00 i od 22.00 do 24.00</li>
        </ul>
            <div className="subtitle">WIELKA SOBOTA</div>
            <p>
                Trwamy w ciszy Grobu Pańskiego – zachęcam do zachowania postnego charakteru
                tego dnia. Znajdźmy czas na adorację Najświętszego Sakramentu.
            </p>
            <p>Tradycyjne poświęcenie pokarmów:</p>
            <ul>
                <li>W kościele: godz. 8.00, 9.00, 10.00, 11.00, 12.00</li>
                <li>W kaplicy na Łowiczkach: godz. 9.00</li>
            </ul>
            <p>
                Przychodząc na poświęcenie, pamiętajmy o trwającej adoracji. Zachowajmy ciszę i skupienie,
                pozostańmy na chwilę modlitwy przy Grobie Pańskim.
            </p>
            <p>Liturgia Wigilii Paschalnej o godz. 18.00 (przychodzimy ze świecami):</p>
            <ol>
                <li>Poświęcenie ognia i Paschału</li>
                <li>Exultet – Orędzie Wielkanocne</li>
                <li>Liturgia Słowa</li>
                <li>Poświęcenie wody i odnowienie przyrzeczeń chrzcielnych</li>
                <li>Liturgia Eucharystyczna</li>
                <li>Rezurekcja – ze względu na prace budowlane nie wyjdziemy na procesję rezurekcyjną</li>
            </ol>

            <div className="subtitle">NIEDZIELA ZMARTWYCHWSTANIA PAŃSKIEGO</div>
            <p>Msze św. w porządku niedzielnym.</p>

            <div className="subtitle">PONIEDZIAŁEK WIELKANOCNY</div>
            <p>
                Msze św. w porządku niedzielnym. Składka przeznaczona na edukację katolicką – Uniwersytet Papieski Jana Pawła II w Krakowie.
            </p>
            <p>
                Dziękuję za sprzątanie kościoła na dzisiejszą niedzielę i ofiarę 200zł, proszę o
                przygotowanie świątynii na czasa świąteczny (w czwartek) rodziny:
            </p>
            <ul>
                <li>Edwarda i Teresy Kobiałka</li>
                <li>Genowefy Kiszczak</li>
                <li>Marka i Anny Knutel</li>
                <li>Wojciecha i Anny Kuwik</li>
                <li>Andrzeja i Grażyny Piwowarskich</li>
            </ul>
            <p>
                Dziękuję za sprzątanie kaplicy Janowi Gliwie i rodz.Wędrzyk, na czas świątecznyę
                troskę o kaplicę powierzamy członkiniom KGW.
            </p>

            <h1>ADORACJA W CIEMNICY</h1>
            <h2>WIELKI PIĄTEK</h2>
            
            <div>godz. 6.00 – I Róża</div>
            <div>godz. 7.00 – II Róża</div>
            <div>godz. 8.00 – III Róża</div>
            <div>godz. 9.00 – IV Róża</div>
            <div>godz. 10.00 – Dzieci szkolne</div>
            <div>godz. 11.00 – V Róża</div>
            <div>godz. 12.00 – VI Róża</div>
            <div>godz. 13.00 – VII Róża</div>
            <div>godz. 14.00 – Róża z Łowiczek</div>
            <div>godz. 15.00 – DROGA KRZYŻOWA</div>
            <div>godz. 16.00 – Kandydaci do Bierzmowania</div>

            <h1>ADORACJA W GROBIE PAŃSKIM</h1>
            <h2>WIELKI PIĄTEK / WIELKA SOBOTA</h2>

            <div>godz. 22.00 – Bractwo NSPJ</div>
            <div>godz. 23.00 – Koło Gospodyń Wiejskich</div>
            <div>godz. 24.00 – ul.Lipowa</div>
            <div>godz. 1.00 – ul.Akacjowa</div>
            <div>godz. 2.00 – ul.Żródlana, Kościelna, Jaśminowa</div>
            <div>godz. 3.00 – ul.Bukowiecka, Granice Głębowskie</div>
            <div>godz. 4.00 – ul.Pagórkowa</div>
            <div>godz. 5.00 – ul.Modrzewiowa</div>
            <div>godz. 6.00 – ul.Kasztanowa</div>
            <div>godz. 7.00 – ul.Wrzosowa</div>
            <div>godz. 8.00 – ul.Węglarzówka</div>
            <div>godz. 9.00 – Róże I – IV</div>
            <div>godz. 10.00 – Róże V – VII</div>
            <div>godz. 11.00 – Kandydaci do Bierzmowania z rodzicami</div>
            <div>godz. 12.00 – Dzieci I Komunijne z rodzicami</div>
            <div>godz. 13.00 – ul.Andrychowska od Przeciszowa do pomnika</div>
            <div>godz. 14.00 – ul.Andrychowska od pomnika do krzyża</div>
            <div>godz. 15.00 – ul.Andrychowska od Gierałtowic do krzyża</div>
            <div>godz. 16.00 – Łowiczki</div>
            <div>godz. 17.00 – Ministranci</div>
        </div>
        <Footer />
  </>
  );
}

export default Ogloszenia;
